:host {
  display: block;
  width: 100%;
  border-radius: 1.25rem;
  padding: 0;
  border-top: 0;
  position: relative;
}

[role=listbox] {
  position: absolute;
  margin-top: var(--pl-space-xs);
  background: var(--pl-color-bg-default);
  border-radius: 1.25rem;
  box-shadow: rgba(140, 149, 159, 0.3) 0px 8px 24px 0px;
  width: 100%;
  overflow: hidden;
  z-index: 1;

  display: flex;
  flex-direction: column;
}

p {
  margin: 0;
  font-size: var(--pl-font-size-s);
  color: var(--pl-color-fg-subtle);
  padding: var(--pl-space-xs) calc(var(--pl-space-m) + var(--pl-space-2xs));
  font-size: var(--pl-font-size-s);
  order: 2;
  font-weight: 500;
  background: var(--pl-color-bg-subtle);
  border-radius: 0 0 1.25rem 1.25rem;

  display: flex;
  gap: var(--pl-space-s) var(--pl-space-l);
  flex-wrap: wrap;
}

ol {
  list-style: none;
  margin: 0;
  padding: var(--pl-space-xs) 0;
  order: 1;
}

[role=option] {
  color: var(--pl-color-fg-default);
  padding: var(--pl-space-s) calc(var(--pl-space-m) + var(--pl-space-2xs));
  text-decoration: none;
  font-weight: 700; 

  &:hover {
    cursor: pointer;
  }

  &:hover,
  &:focus {
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
    text-decoration: underline;
  }
}

[aria-selected=true] {
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
  text-decoration: underline;
}

mark,
b {
  background: none;
  font-weight: 400;
}

.suggestion--border {
  border-bottom: solid 1px rgb(from var(--pl-color-fg-default) r g b / 0.2);
  padding-bottom: calc(var(--pl-space-2xs) + var(--pl-space-s));
  margin-bottom: var(--pl-space-2xs);
}